/**
 * @generated SignedSource<<6eae1169dafc0e672e77a1dd27381d1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebhookSubscriptionType = "DATADOG" | "FIREHYDRANT" | "INCIDENT_IO" | "OPSGENIE" | "PAGERDUTY" | "ROOTLY" | "SLACK" | "%future added value";
export type CreateOrUpdateWebhookSubscriptionInput = {
  webhookConfigs: ReadonlyArray<WebhookSubscriptionConfigInput>;
  webhookSubscriptionType: WebhookSubscriptionType;
};
export type WebhookSubscriptionConfigInput = {
  id?: any | null | undefined;
  name: string;
  opsgenieApiKey?: string | null | undefined;
  remoteId: string;
  secret: string;
};
export type PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables = {
  input: CreateOrUpdateWebhookSubscriptionInput;
};
export type PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation$data = {
  readonly createOrUpdateWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly webhookSubscriptions: ReadonlyArray<{
      readonly id: any;
      readonly name: string;
      readonly remoteId: string;
    }> | null | undefined;
  };
};
export type PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation = {
  response: PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation$data;
  variables: PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrUpdateWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "createOrUpdateWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLWebhookSubscription",
        "kind": "LinkedField",
        "name": "webhookSubscriptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "688601bda894cf513b0e5de4171e7e8b",
    "id": null,
    "metadata": {},
    "name": "PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation PagerDutyIntegrationCreateOrUpdateWebhookSubscriptionMutation(\n  $input: CreateOrUpdateWebhookSubscriptionInput!\n) {\n  createOrUpdateWebhookSubscription(input: $input) {\n    webhookSubscriptions {\n      id\n      name\n      remoteId\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "14202d887dddfdc232ea44b41d327b2d";

export default node;
